import { all, put, fork, takeEvery, select, delay } from 'redux-saga/effects';
import actions from './actions';
import onboardingAction from '@iso/redux/onboarding/actions';
import transactionActions from '@iso/redux/transactions/actions';
import { get, post, PUT, DELETE, patch } from '@iso/lib/helpers/resApiRequestor';
import { REQUEST } from '@iso/containers/constants';

export function* resetTokenData() {
  yield takeEvery('RESET_TOKEN_DATA', function* (payload) {
    try {
      const apiResult = yield resettingTokenData(payload.payload);
      const result = apiResult.data;
      yield put({
        type: actions.RESETTING_TOKEN_DATA
      });
      if (result.success) {
        yield put({
          type: actions.RESET_TOKEN_DATA_SUCCESS,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.RESET_TOKEN_DATA_FAILED
        });
      }
    } catch (error) {
      yield put({
        type: actions.RESET_TOKEN_DATA_FAILED
      });
    }
  });
}

export function* newResetMerchantUserPassword() {
  yield takeEvery('NEW_RESET_MERCHANT_USER_PASSWORD', function* (payload) {
    try {
      yield put({
        type: actions.NEW_RESETTING_MERCHANT_USER_PASSWORD
      });
      const apiResult = yield newResetMerchantUserPasswordRequest(
        payload.payload.newData,
        payload.payload.id
      );
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.NEW_MERCHANT_USER_PASSWORD_RESET_SUCCESS,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.NEW_MERCHANT_USER_PASSWORD_RESET_FAILED
        });
      }
    } catch (error) {
      yield put({
        type: actions.NEW_MERCHANT_USER_PASSWORD_RESET_ERROR
      });
    }
  });
}

export function* fetchAllMerchants() {
  yield takeEvery('FETCH_MERCHANT_DATA', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination?.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_DATA
        });
      } else {
        yield put({
          type: actions.FETCHING_MERCHANT_DATA,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllMerchantAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData =
        pagination?.currentList && pagination?.loadMore && pagination?.currentList?.length > 0
          ? pagination?.currentList
          : [];

      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_DATA_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result?.pagination,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchMerchantFiles() {
  yield takeEvery(actions.FETCH_MERCHANT_FILES, function* ({ payload, pagination }) {
    try {
      const loadmore = pagination?.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_FILES
        });
      } else {
        yield put({
          type: actions.FETCHING_MERCHANT_FILES,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData =
        pagination?.currentList && pagination?.loadMore && pagination?.currentList?.length > 0
          ? pagination?.currentList
          : [];

      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_FILES_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result?.pagination,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_FILES_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_FILES_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchPtiTestMerchantUsers() {
  yield takeEvery('FETCH_PTI_TEST_MERCHANT_USERS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination?.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_PTI_TEST_MERCHANT_USERS
        });
      } else {
        yield put({
          type: actions.FETCHING_PTI_TEST_MERCHANT_USERS,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPtiMerchantUsersAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData =
        pagination?.currentList && pagination?.loadMore && pagination?.currentList?.length > 0
          ? pagination?.currentList
          : [];

      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PTI_TEST_MERCHANT_USERS_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result?.pagination,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_PTI_TEST_MERCHANT_USERS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PTI_TEST_MERCHANT_USERS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchPtiProdMerchantUsers() {
  yield takeEvery('FETCH_PTI_PROD_MERCHANT_USERS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination?.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_PTI_PROD_MERCHANT_USERS
        });
      } else {
        yield put({
          type: actions.FETCHING_PTI_PROD_MERCHANT_USERS,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPtiMerchantUsersAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData =
        pagination?.currentList && pagination?.loadMore && pagination?.currentList?.length > 0
          ? pagination?.currentList
          : [];

      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PTI_PROD_MERCHANT_USERS_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result?.pagination,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_PTI_PROD_MERCHANT_USERS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PTI_PROD_MERCHANT_USERS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchPtiMerchantUsers() {
  yield takeEvery('FETCH_PTI_MERCHANT_USERS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination?.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_PTI_MERCHANT_USERS
        });
      } else {
        yield put({
          type: actions.FETCHING_PTI_MERCHANT_USERS,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPtiMerchantUsersAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData =
        pagination?.currentList && pagination?.loadMore && pagination?.currentList?.length > 0
          ? pagination?.currentList
          : [];

      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PTI_MERCHANT_USERS_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result?.pagination,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_PTI_MERCHANT_USERS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PTI_MERCHANT_USERS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchParentMerchants() {
  yield takeEvery('FETCH_PARENT_MERCHANT_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_PARENT_MERCHANT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchParentMerchantAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PARENT_MERCHANT_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PARENT_MERCHANT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_PARENT_MERCHANT_DATA_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PARENT_MERCHANT_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAmountLevel() {
  yield takeEvery('FETCH_MERCHANT_AMOUNT_LEVEL_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_AMOUNT_LEVEL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAmountLevelAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}
export function* fetchElasticMerchants() {
  yield takeEvery('FETCH_ELASTIC_MERCHANT_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_ELASTIC_MERCHANT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchElasticMerchantAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        let currData = result.data;
        currData.forEach(function (data) {
          data['name'] = data['mid_name'] ? data['mid_name'].trim() : 'Merchant Name';
          data['merchant_id'] = data['key'].trim();
          data['id'] = data['id'] ? data['id'] : data['key'].trim();
          data['service'] = 'Paygate';
          delete data['mid_name'];
          delete data['key'];
        });

        yield put({
          type: actions.FETCH_ELASTIC_MERCHANT_DATA_SUCCESS,
          loading: false,
          result: result && currData ? currData : null
        });
      } else {
        yield put({
          type: actions.FETCH_ELASTIC_MERCHANT_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ELASTIC_MERCHANT_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchMerchantByID() {
  yield takeEvery('FETCH_MERCHANT_DATA_BY_ID', function* ({ payload, resolve, reject  }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_DATA_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        if (result && result.data && result.data.merchant_type && result.data.merchant_info_id) {
          yield put({
            type: actions.FETCH_MERCHANT_INFO_MIDS,
            payload: result.data
          });

          yield put({
            type: actions.FETCH_MERCHANT_INFO_BY_ID,
            payload: result.data.merchant_info_id
          });
        }

        yield put({
          type: actions.FETCH_MERCHANT_DATA_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        if (resolve) resolve(result.data); // ✅ send back data to caller
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_DATA_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
        if (reject) reject(result.message || 'Failed to process request');
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_DATA_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
      if (reject) reject('Failed to process request');
    }
  });
}

export function* fetchMerchantCredentialsByMerchantManagementId() {
  yield takeEvery(actions.FETCH_MERCHANT_CREDENTIALS, function* ({ id, payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_CREDENTIALS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantCredentialsByMerchantManagementIdAPI(id, payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        
        yield put({
          type: actions.FETCH_MERCHANT_CREDENTIALS_SUCCESS,
          loading: false,
          message: payload?.is_default_fetch ? null : result.message,
          result: result ? result.data : null,
          pagination: result?.pagination,
          filter: payload

        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_CREDENTIALS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_CREDENTIALS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* loadMoreMerchantCredentials() {
  yield takeEvery(actions.LOAD_MORE_MERCHANT_CREDENTIALS, function* ({ id, payload, pagination }) {
    try {
      yield put({
        type: actions.LOADING_MORE_MERCHANT_CREDENTIALS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantCredentialsByMerchantManagementIdAPI(id, payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.LOAD_MORE_MERCHANT_CREDENTIALS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null,
          pagination: result?.pagination,
          filter: payload
        });
      } else {
        yield put({
          type: actions.LOAD_MORE_MERCHANT_CREDENTIALS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOAD_MORE_MERCHANT_CREDENTIALS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}


export function* addNewMerchantCertificate() {
  yield takeEvery(actions.ADD_NEW_MERCHANT_CERTIFICATE, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.ADDING_NEW_MERCHANT_CERTIFICATE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addNewMerchantCertificateAPI(
        payload,
        pagination,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_NEW_MERCHANT_CERTIFICATE_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null,
          pagination: result?.pagination
        });
      } else {
        yield put({
          type: actions.ADD_NEW_MERCHANT_CERTIFICATE_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_NEW_MERCHANT_CERTIFICATE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMerchantCertificateV2() {
  yield takeEvery(actions.UPDATE_MERCHANT_CERTIFICATE_V2, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_CERTIFICATE_V2,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantCertificateV2API(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_CERTIFICATE_V2_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        if (result.log) {
          yield put ({
            type: actions.UPDATE_AUDIT_LOGS,
            log: result.log
          })
        }
      } else {
        yield put({
          type: actions.UPDATE_MERCHANT_CERTIFICATE_V2_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_CERTIFICATE_V2_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMidCertificate() {
  yield takeEvery(actions.UPDATE_MID_CERTIFICATE, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MID_CERTIFICATE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMidCertificateAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_MID_CERTIFICATE_SUCCESS,
          loading: false,
          message: result.message,
        });
      } else {
        yield put({
          type: actions.UPDATE_MID_CERTIFICATE_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MID_CERTIFICATE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}


export function* fetchMerchantCertificates() {
  yield takeEvery(actions.FETCH_MERCHANT_CERTIFICATES, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_CERTIFICATES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantCertificatesAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_CERTIFICATES_SUCCESS,
          loading: false,
          message: payload?.is_default_fetch ? null : result.message,
          result: result ? result.data : null,
          pagination: result?.pagination,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_CERTIFICATES_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_CERTIFICATES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantCredentialById() {
  yield takeEvery(actions.FETCH_MERCHANT_CREDENTIAL_BY_ID, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_CREDENTIAL_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantCredentialByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_CREDENTIAL_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null,
          filter: payload
        });

        if (result.log) {
          yield put ({
            type: actions.UPDATE_AUDIT_LOGS,
            log: result.log
          })
        }
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_CREDENTIAL_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_CREDENTIAL_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantKrakenPaymentChannelsByMid() {
  yield takeEvery(actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantKrakenPaymentChannelsByMidAPI(payload, roleHeaderAuth);

      const { is_initial_fetch } = payload;
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_SUCCESS,
          loading: false,
          ...(is_initial_fetch !== true && {
            message: result?.message,
          }),
          result: result ? result.data : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMerchantKrakenPaymentChannelByMid() {
  yield takeEvery(actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantKrakenPaymentChannelByMidAPI(payload, roleHeaderAuth);

      const { is_initial_fetch } = payload;
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS,
          loading: false,
          ...(is_initial_fetch !== true && {
            message: result?.message
          }),
          result: result ? result.data : null,
          filter: payload
        });
        if (result.log) {
          yield put ({
            type: actions.UPDATE_AUDIT_LOGS,
            log: result.log
          })
        }
      } else {
        yield put({
          type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMerchantKrakenPaymentChannelByMidStatus() {
  yield takeEvery(actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantKrakenPaymentChannelByMidStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_SUCCESS,
          loading: false,
          message: result?.message,
          result: result ? result.data : null,
          filter: payload
        });

        if (result.log) {
          yield put ({
            type: actions.UPDATE_AUDIT_LOGS,
            log: result.log
          })
        }
      } else {
        yield put({
          type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* migrateMerchantKrakenPaymentByMid() {
  yield takeEvery(
    actions.MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.MIGRATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield migrateMerchantKrakenPaymentByMidAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS,
            loading: false,
            message: result?.message,
            result: result ? result.data : null,
            filter: payload
          });

          if (result.log) {
            yield put ({
              type: actions.UPDATE_AUDIT_LOGS,
              log: result.log
            })
          }
          
        } else {
          yield put({
            type: actions.MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED,
            message: result.message,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}


export function* fetchPaybizDetailsByID() {
  yield takeEvery('FETCH_PAYBIZ_DETAILS_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYBIZ_DETAILS_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPaybizDetailsData(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYBIZ_DETAILS_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_PAYBIZ_DETAILS_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYBIZ_DETAILS_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchIntegrationFormRequestByID() {
  yield takeEvery('FETCH_INTEGRATION_FORM_REQUEST_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INTEGRATION_FORM_REQUEST_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchIntegrationFormRequestByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INTEGRATION_FORM_REQUEST_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_INTEGRATION_FORM_REQUEST_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INTEGRATION_FORM_REQUEST_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchPaybizMerchants() {
  yield takeEvery('FETCH_PAYBIZ_MERCHANTS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYBIZ_MERCHANTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPaybizDetailsData(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYBIZ_MERCHANTS_SUCCESS,
          loading: false,
          message: result.message,
          filter: payload,
          result: result ? result.data : [],
          total:
            result && result.pagination && result.pagination.total ? result.pagination.total : 1000
        });
      } else {
        yield put({
          type: actions.FETCH_PAYBIZ_MERCHANTS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYBIZ_MERCHANTS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchMerchantConfiguration() {
  yield takeEvery('FETCH_MERCHANT_CONFIG_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_CONFIG_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantConfigAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_CONFIG_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result:
            result && result.data && result.data.configuration ? result.data.configuration : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_CONFIG_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_CONFIG_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchMerchantSettingsType() {
  yield takeEvery('FETCH_MERCHANT_SETTINGS_TYPE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_SETTINGS_TYPE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantSettingsTypeAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS,
          loading: false,
          message: result.message,
          dataFilter: payload,
          result: result ? result.data : []
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_SETTINGS_TYPE_DATA_FAILED,
          message: result.message,
          dataFilter: payload,
          loading: false,
          result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_SETTINGS_TYPE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false,
        dataFilter: payload,
        result: []
      });
    }
  });
}
export function* fetchMerchantPchannelByID() {
  yield takeEvery('FETCH_MERCHANT_PCHANNEL_DATA_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_PCHANNEL_DATA_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantPChannelByIDAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_FAILED,
            message: result.message || 'Failed to process request',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchMerchantLogsByID() {
  yield takeEvery('FETCH_MERCHANT_LOGS_DATA_BY_ID', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_LOGS_DATA_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantLogsByIDAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_LOGS_DATA_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result && result.data ? result.data : null,
          pagination: result ? result.pagination : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_MERCHANT_LOGS_DATA_BY_ID_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_MERCHANT_LOGS_DATA_BY_ID_FAILED,
            message: 'Failed to process request',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_LOGS_DATA_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchMerchantFilesByID() {
  yield takeEvery('FETCH_FILE_MANAGEMENT_DATA', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_FILE_MANAGEMENT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantFilesByIDAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_FILE_MANAGEMENT_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result && result.data ? result.data : null,
          pagination: result ? result.pagination : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_FILE_MANAGEMENT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_FILE_MANAGEMENT_DATA_FAILED,
            message: 'Failed to process request',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FILE_MANAGEMENT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addMerchantData() {
  yield takeEvery('ADD_MERCHANT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_MERCHANT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addPtiMerchantUser() {
  yield takeEvery('ADD_PTI_DASHBOARD_USER', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_PTI_DASHBOARD_USER,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addPTIDashboardUserAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_PTI_DASHBOARD_USER_SUCCESS,
          loading: false,
          message: result.message,
          result: result?.data ?? [],
          email_added: payload?.emails?.length ?? 0
        });

        if (result.log) {
          yield put ({
            type: actions.UPDATE_AUDIT_LOGS,
            log: result.log
          })
        }
        // if (payload && payload.env.toUpperCase() === 'TEST' && payload.merchant_id) {
        //   yield put({
        //     type: actions.FETCH_PTI_TEST_MERCHANT_USERS,
        //     payload: { env: payload.env, merchant_id: payload.merchant_id }
        //   });
        // } else if (payload && payload.env.toUpperCase() === 'PROD' && payload.merchant_id) {
        //   yield put({
        //     type: actions.FETCH_PTI_PROD_MERCHANT_USERS,
        //     payload: { env: payload.env, merchant_id: payload.merchant_id }
        //   });
        // }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PTI_DASHBOARD_USER_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_PTI_DASHBOARD_USER_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_PTI_DASHBOARD_USER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* registerDashboardMerchantAccount() {
  yield takeEvery('REGISTER_PTI_DASHBOARD_USER', function* ({ payload }) {
    try {
      yield put({
        type: actions.REGISTERING_PTI_DASHBOARD_USER,
        loading: true
      });

      const apiResult = yield registerDashboardMerchantAccountAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REGISTER_PTI_DASHBOARD_USER_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.REGISTER_PTI_DASHBOARD_USER_FAILED,
          message: result.message ? result.message : 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REGISTER_PTI_DASHBOARD_USER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updatePtiMerchantUser() {
  yield takeEvery('UPDATE_PTI_DASHBOARD_USER', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_PTI_DASHBOARD_USER,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updatePTIDashboardUserAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_PTI_DASHBOARD_USER_SUCCESS,
          loading: false,
          message: result.message,
          result: result?.data ?? []
        });

        if (result.log) {
          yield put ({
            type: actions.UPDATE_AUDIT_LOGS,
            log: result.log
          })
        }
        // if (payload && payload.env.toUpperCase() === 'TEST' && payload.merchant_id) {
        //   yield put({
        //     type: actions.FETCH_PTI_TEST_MERCHANT_USERS,
        //     payload: { env: payload.env, merchant_id: payload.merchant_id }
        //   });
        // } else if (payload && payload.env.toUpperCase() === 'PROD' && payload.merchant_id) {
        //   yield put({
        //     type: actions.FETCH_PTI_PROD_MERCHANT_USERS,
        //     payload: { env: payload.env, merchant_id: payload.merchant_id }
        //   });
        // }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_PTI_DASHBOARD_USER_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_PTI_DASHBOARD_USER_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_PTI_DASHBOARD_USER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchInvitedMerchantUserDetails() {
  yield takeEvery('FETCH_INVITED_MERCHANT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INVITED_MERCHANT_USER_DATA,
        loading: true
      });

      const apiResult = yield fetchInvitedMerchantUserDataAPI(payload);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INVITED_MERCHANT_USER_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_INVITED_MERCHANT_USER_DATA_FAILED,
          loading: false,
          result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INVITED_MERCHANT_USER_DATA_FAILED,
        payload: [],
        loading: false
      });
    }
  });
}

export function* addMerchantInformation() {
  yield takeEvery('ADD_MERCHANT_INFORMATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_INFORMATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantInformationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_MERCHANT_INFORMATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_MERCHANT_INFORMATION
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_INFORMATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_INFORMATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllMerchantInfo() {
  yield takeEvery('FETCH_ALL_MERCHANT_INFORMATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_MERCHANT_INFORMATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const merchantFilter = { keyword: payload ? payload : '' };

      const apiResult = yield fetchAllMerchantInformationAPI(merchantFilter, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_INFORMATION_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          filter: merchantFilter
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_INFORMATION_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_MERCHANT_INFORMATION_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchMerchantInfoByID() {
  yield takeEvery('FETCH_MERCHANT_INFO_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_INFO_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantInfoByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_INFO_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_INFO_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_INFO_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantInformation() {
  yield takeEvery('EDIT_MERCHANT_INFO', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_INFO,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantInformationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_INFO_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_MERCHANT_INFORMATION
        });
        yield put({
          type: actions.FETCH_MERCHANT_INFO_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_INFO_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_INFO_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_INFO_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* inviteMerchantData() {
  yield takeEvery('INVITE_MERCHANT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.INVITING_MERCHANT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield inviteMerchantDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.INVITE_MERCHANT_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.INVITE_MERCHANT_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.INVITE_MERCHANT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchInvitedMerchantDetails() {
  yield takeEvery('FETCH_INVITED_MERCHANT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INVITED_MERCHANT_DATA,
        loading: true
      });

      const apiResult = yield fetchInvitedMerchantDataAPI(payload);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INVITED_MERCHANT_DATA_SUCCESS,
          loding: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_INVITED_MERCHANT_DATA_FAILED,
          loading: false,
          result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INVITED_MERCHANT_DATA_FAILED,
        payload: [],
        loading: false
      });
    }
  });
}

export function* logAccessMerchantInvite() {
  yield takeEvery('LOG_ACCESS_MERCHANT_INVITE_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.LOGGING_ACCESS_INVITE_DATA,
        loading: true
      });
      const apiResult = yield logAccessMerchantInviteAPI(payload, id);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.LOG_ACCESS_MERCHANT_INVITE_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.LOG_ACCESS_MERCHANT_INVITE_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOG_ACCESS_MERCHANT_INVITE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addMerchantConfigurationData() {
  yield takeEvery('ADD_MERCHANT_CONFIGURATION_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_CONFIGURATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantConfigurationDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_MERCHANT_CONFIGURATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_CONFIG_DATA,
          payload: payload.merchant_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_CONFIGURATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_CONFIGURATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_CONFIGURATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addMerchantSettingsType() {
  yield takeEvery('ADD_MERCHANT_SETTINGS_TYPE', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_SETTINGS_TYPE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantSettingsTypeAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_MERCHANT_SETTINGS_TYPE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_SETTINGS_TYPE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_SETTINGS_TYPE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_SETTINGS_TYPE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_SETTINGS_TYPE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addAmountLevel() {
  yield takeEvery('ADD_AMOUNT_LEVEL', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_AMOUNT_LEVEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addAmountLevelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_AMOUNT_LEVEL_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_AMOUNT_LEVEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_AMOUNT_LEVEL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_AMOUNT_LEVEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editMigratedMid() {
  yield takeEvery(actions.EDIT_MIGRATED_MID, function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MIGRATED_MID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMigratedMidAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MIGRATED_MID_SUCCESS,
          loading: false,
          message: result.message,
          merchant_id: result?.data?.merchant_id ?? payload?.merchant_id,
          merchant_management_id: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MIGRATED_MID_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MIGRATED_MID_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MIGRATED_MID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantBasicInformationData() {
  yield takeEvery('EDIT_MERCHANT_BASIC_INFORMATION_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_BASIC_INFORMATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantBasicInformationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_BASIC_INFORMATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_BASIC_INFORMATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_BASIC_INFORMATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_BASIC_INFORMATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editMerchantOwnerInformationData() {
  yield takeEvery('EDIT_MERCHANT_OWNER_INFORMATION_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_OWNER_INFORMATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantOwnerInformationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_OWNER_INFORMATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_OWNER_INFORMATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_OWNER_INFORMATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_OWNER_INFORMATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editMerchantContactInformationData() {
  yield takeEvery('EDIT_MERCHANT_CONTACT_INFORMATION_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_CONTACT_INFORMATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantContactInformationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_CONTACT_INFORMATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_CONTACT_INFORMATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_CONTACT_INFORMATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_CONTACT_INFORMATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editMerchantServiceInformationData() {
  yield takeEvery('EDIT_MERCHANT_SERVICE_INFORMATION_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_SERVICE_INFORMATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantServiceInformationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_SERVICE_INFORMATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_SERVICE_INFORMATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_SERVICE_INFORMATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_SERVICE_INFORMATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantPChannelInformationData() {
  yield takeEvery('EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA', function* ({ payload, id, request }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_PCHANNEL_INFORMATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantPChannelInformationAPI(
        payload,
        id,
        roleHeaderAuth,
        request
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID,
          payload: { merchant_id: id }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* deleteMerchantData() {
  yield takeEvery('DELETE_MERCHANT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_MERCHANT_DATA,
        loading: true,
        isError: false
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteMerchantDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_MERCHANT_DATA_SUCCESS,
          loading: false,
          message: result.message,
          isError: false
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_MERCHANT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            isError: true
          });
        } else {
          yield put({
            type: actions.DELETE_MERCHANT_DATA_FAILED,
            message: result.message,
            loading: false,
            isError: true
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_MERCHANT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false,
        isError: true
      });
    }
  });
}
export function* filterMerchantData() {
  yield takeEvery('FILTER_MERCHANT', function* ({ payload }) {
    try {
      yield put({
        type: actions.FILTERING_MERCHANT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield filterMerchantAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FILTER_MERCHANT_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FILTER_MERCHANT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FILTER_MERCHANT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FILTER_MERCHANT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* uploadFileData() {
  yield takeEvery('UPLOAD_FILE_DATA', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.UPLOADING_FILE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield uploadFileDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPLOAD_FILE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_FILE_MANAGEMENT_DATA,
          payload: { merchant_id: payload.merchant_id },
          pagination
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_FILE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else if (result.status === 413) {
          yield put({
            type: actions.UPLOAD_FILE_DATA_FAILED,
            message: `Your request exceeded the system limit size`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_FILE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_FILE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* downloadFileData() {
  yield takeEvery('DOWNLOAD_FILE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_FILE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadFileDataAPI(payload, roleHeaderAuth);
      const state = yield select();
      const fileDownloadData = state.Merchant.fileDownloadData;

      const result = apiResult.data;

      if (!result.success) {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_FILE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            payload: fileDownloadData
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_FILE_DATA_FAILED,
            message: result.message,
            loading: false,
            payload: fileDownloadData
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_FILE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false,
        payload: null
      });
    }
  });
}
export function* deleteFileData() {
  yield takeEvery('DELETE_FILE_DATA', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.DELETING_FILE_DATA,
        loading: true,
        isError: false
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteFileDataAPI(payload.id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_FILE_DATA_SUCCESS,
          loading: false,
          message: result.message,
          isError: false
        });
        yield put({
          type: actions.FETCH_FILE_MANAGEMENT_DATA,
          payload: { merchant_id: payload.merchant_id },
          pagination
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_FILE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            isError: true
          });
        } else {
          yield put({
            type: actions.DELETE_FILE_DATA_FAILED,
            message: result.message,
            loading: false,
            isError: true
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_FILE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false,
        isError: true
      });
    }
  });
}
export function* editMerchantAmountLevelData() {
  yield takeEvery('EDIT_MERCHANT_AMOUNT_LEVEL_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_AMOUNT_LEVEL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantAmountLevelAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_AMOUNT_LEVEL_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_AMOUNT_LEVEL_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_AMOUNT_LEVEL_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantSettingsTypeData() {
  yield takeEvery('EDIT_MERCHANT_SETTINGS_TYPE_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_SETTINGS_TYPE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantSettingsTypeAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_SETTINGS_TYPE_DATA
        });
        yield put({
          type: actions.FETCH_MERCHANT_DATA_BY_ID,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_SETTINGS_TYPE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_SETTINGS_TYPE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_SETTINGS_TYPE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editMerchantConfigData() {
  yield takeEvery('EDIT_MERCHANT_CONFIG_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_CONFIG_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantConfigAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_CONFIG_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_CONFIG_DATA,
          payload: payload.merchant_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_CONFIG_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_CONFIG_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_CONFIG_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchMerchantPChannelCredentialByID() {
  yield takeEvery('FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_PCHANNEL_CREDENTIAL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantPChannelCredentialAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result && result.data ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchMerchantFees() {
  yield takeEvery('FETCH_MERCHANT_FEE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_FEE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantFeesAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_FEE_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result && result.data ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_FEE_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_FEE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* setupMerchantPChannelCredential() {
  yield takeEvery('SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.SETTING_UP_MERCHANT_PCHANNEL_CREDENTIAL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield setupMerchantPChannelCredentialAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* setupMerchantFee() {
  yield takeEvery('SETUP_MERCHANT_FEE_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.SETTING_UP_MERCHANT_FEE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield setupMerchantFeeAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SETUP_MERCHANT_FEE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MERCHANT_FEE_DATA,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.SETUP_MERCHANT_FEE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.SETUP_MERCHANT_FEE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SETUP_MERCHANT_FEE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMISOptionsData() {
  yield takeEvery('FETCH_MIS_OPTIONS', function* () {
    try {
      yield put({
        type: actions.FETCHING_MIS_OPTIONS,
        loading: true
      });

      const apiResult = yield fetchMISOptionsDataAPI();

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MIS_OPTIONS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MIS_OPTIONS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MIS_OPTIONS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchKybLinkStatus() {
  yield takeEvery(actions.FETCH_KYB_LINK_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_KYB_LINK_STATUS,
        loading: true
      });

      const apiResult = yield fetchKybLinkStatusAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_KYB_LINK_STATUS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_KYB_LINK_STATUS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_KYB_LINK_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantMISDetails() {
  yield takeEvery('FETCH_MIS_MERCHANT_DETAILS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MIS_MERCHANT_DETAILS,
        loading: true
      });

      const apiResult = yield fetchMISMerchantDetailsAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MIS_MERCHANT_DETAILS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MIS_MERCHANT_DETAILS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MIS_MERCHANT_DETAILS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* logAccessMIS() {
  yield takeEvery('LOG_ACCESS_MIS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.LOGGING_ACCESS_MIS,
        loading: true
      });
      const apiResult = yield logAccessMISAPI(payload, id);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.LOG_ACCESS_MIS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.LOG_ACCESS_MIS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOG_ACCESS_MIS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* submitMISFormData() {
  yield takeEvery('SUBMIT_MIS_FORM_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.SUBMITTING_MIS_FORM_DATA,
        loading: true
      });

      const apiResult = yield submitMISFormDataAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.SUBMIT_MIS_FORM_DATA_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MIS_MERCHANT_DETAILS,
          payload: payload.mis_id
        });
      } else {
        yield put({
          type: actions.SUBMIT_MIS_FORM_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.SUBMIT_MIS_FORM_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* saveMISDraft() {
  yield takeEvery('SAVE_MIS_DRAFT', function* ({ payload }) {
    try {
      yield put({
        type: actions.SAVING_MIS_DRAFT,
        loading: true
      });

      const apiResult = yield saveMISDraftAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.SAVE_MIS_DRAFT_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        yield put({
          type: actions.SAVE_MIS_DRAFT_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.SAVE_MIS_DRAFT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllMerchantFromOnboarding() {
  yield takeEvery('FETCH_ALL_MERCHANT_FROM_ONBOARDING', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_FROM_ONBOARDING,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_MERCHANT_FROM_ONBOARDING,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllMerchantFromOnboardingAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_FROM_ONBOARDING_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS,
            payload: parseData[0].id
          });
          // yield put({
          //   type: accountOfficerAction.FETCH_MIS_DATA_BY_ID,
          //   payload: parseData[0].id
          // });
          // yield put({
          //   type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID,
          //   payload: { id: parseData[0].id }
          // });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_FROM_ONBOARDING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_FROM_ONBOARDING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_MERCHANT_FROM_ONBOARDING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantServicesAndPaymentChannels() {
  yield takeEvery('FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantServicesAndPaymentChannelsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        yield put({
          type: onboardingAction.FETCH_MERCHANT_ONBOARDING_LOGS,
          payload,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantService() {
  yield takeEvery('EDIT_MERCHANT_SERVICE', function* ({ payload }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_SERVICE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantServiceAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_SERVICE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_SERVICE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_SERVICE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_SERVICE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantPaymentChannel() {
  yield takeEvery('EDIT_MERCHANT_PAYMENT_CHANNEL', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_PAYMENT_CHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let addendumData = [];
      if (
        payload &&
        payload.addendum_files &&
        payload.addendum_files.length === urls.addendum_files.length
      ) {
        const dataFile = payload.addendum_files;
        dataFile.forEach(file => {
          if (urls.addendum_files.some(str => str.includes(file.name))) {
            let getURL = urls.addendum_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              addendumData.push(currentObj);
            }
          }
        });
      }
      const addendumLength = (urls?.addendum_files ?? []).length;

      yield delay(addendumLength * 1000);

      const apiResult = yield editMerchantPaymentChannelAPI(
        { ...payload, addendum_files: addendumData },
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SUCCESS,
          loading: false,
          message: result.message
        });
        yield commonFetchRequests(payload.merchant_mgmt_id);
        yield put({
          type: transactionActions.RESET_ADDENDUM_FOR_UPLOAD
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getAllCosmosLeadMerchant() {
  yield takeEvery('FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS', function* () {
    try {
      yield put({
        type: actions.FETCHING_ALL_COSMOS_LEADS_AND_MERCHANTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getAllCosmosLeadMerchantAPI(roleHeaderAuth);
      const result = apiResult.data;
      let cosmosMerch = null;
      if (result.leads || result.merchants) {
        cosmosMerch = [...result.leads, ...result.merchants];
      }
      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_SUCCESS,
          loading: false,
          message: result.message,
          result: cosmosMerch ? cosmosMerch : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchExistingMerchantLogs() {
  yield takeEvery('FETCH_EXISTING_MERCHANT_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_EXISTING_MERCHANT_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_EXISTING_MERCHANT_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchExistingMerchantLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_EXISTING_MERCHANT_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_EXISTING_MERCHANT_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_EXISTING_MERCHANT_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchAllCompanyInformation() {
  yield takeEvery('FETCH_COMPANY_INFORMATION_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_COMPANY_INFORMATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllCompanyInformationAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_COMPANY_INFORMATION_DATA_SUCCESS,
          loading: false,
          result: result ? result?.data?.company_information : null
        });
      } else {
        yield put({
          type: actions.FETCH_COMPANY_INFORMATION_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_COMPANY_INFORMATION_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* addCompanyInformation() {
  yield takeEvery('ADD_COMPANY_INFORMATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_COMPANY_INFORMATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addCompanyInformationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_COMPANY_INFORMATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_COMPANY_INFORMATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_COMPANY_INFORMATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_COMPANY_INFORMATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_COMPANY_INFORMATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editCompanyInformation() {
  yield takeEvery('EDIT_COMPANY_INFORMATION', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.EDITING_COMPANY_INFORMATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editCompanyInformationAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_COMPANY_INFORMATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_COMPANY_INFORMATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_COMPANY_INFORMATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_COMPANY_INFORMATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_COMPANY_INFORMATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadMerchantFile() {
  yield takeEvery('DOWNLOAD_MERCHANT_FILE', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_MERCHANT_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadMerchantFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_MERCHANT_FILE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_MERCHANT_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllParentMerchants() {
  yield takeEvery('FETCH_ALL_PARENT_MERCHANTS', function* () {
    try {
      yield put({
        type: actions.FETCHING_ALL_PARENT_MERCHANTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllParentMerchantsAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_PARENT_MERCHANTS_SUCCESS,
          loading: false,
          result: result ? result.data : []
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_PARENT_MERCHANTS_FAILED,
          loading: false,
          result: result ? result.data : []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_PARENT_MERCHANTS_FAILED,
        loading: false
      });
    }
  });
}

export function* migrateMerchantInformation() {
  yield takeEvery('MIGRATE_MERCHANT_INFORMATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.MIGRATING_MERCHANT_INFORMATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield migrateMerchantInformationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.MIGRATE_MERCHANT_INFORMATION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_MERCHANT_INFORMATION
        });
        yield put({
          type: actions.FETCH_ALL_PARENT_MERCHANTS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MIGRATE_MERCHANT_INFORMATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.MIGRATE_MERCHANT_INFORMATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MIGRATE_MERCHANT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantInfoMIDs() {
  yield takeEvery('FETCH_MERCHANT_INFO_MIDS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_INFO_MIDS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchMerchantInfoMIDsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_INFO_MIDS_SUCCESS,
          loading: false,
          result: result ? result.data : []
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_INFO_MIDS_FAILED,
          loading: false,
          result: result ? result.data : []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_INFO_MIDS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchIntegrationFormRequests() {
  yield takeEvery('FETCH_INTEGRATION_FORM_REQUESTS', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_INTEGRATION_FORM_REQUESTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchIntegrationFormRequestsAPI(
        {
          ...payload
        },
        pagination,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const integrationFormRequests = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INTEGRATION_FORM_REQUESTS_SUCCESS,
          loading: false,
          result: result && integrationFormRequests ? integrationFormRequests : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_INTEGRATION_FORM_REQUESTS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INTEGRATION_FORM_REQUESTS_FAILED,
        loading: false
      });
    }
  });
}

export function* editIntegrationChannelSubMID() {
  yield takeEvery('EDIT_INTEGRATION_CHANNEL_SUB_MID', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_INTEGRATION_CHANNEL_SUB_MID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editIntegrationChannelSubMIDAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_INTEGRATION_CHANNEL_SUB_MID_SUCCESS,
          loading: false,
          message: result.message
        });

        const integrationFormRequestById = payload?.integration_form_request_id;

        if (integrationFormRequestById) {
          yield put({
            type: actions.FETCH_INTEGRATION_FORM_REQUEST_BY_ID,
            payload: { integration_form_request_id: integrationFormRequestById }
          });

          yield put({
            type: actions.FETCH_INTEGRATION_FORM_LOGS,
            payload: { integration_form_requests: [id] },
            pagination: { page: 0, limit: 20 }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_INTEGRATION_CHANNEL_SUB_MID_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_INTEGRATION_CHANNEL_SUB_MID_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_INTEGRATION_CHANNEL_SUB_MID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateIntegrationFormRequestStatus() {
  yield takeEvery('UPDATE_INTEGRATION_FORM_REQUEST_STATUS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_INTEGRATION_FORM_REQUEST_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateIntegrationFormRequestStatusAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_INTEGRATION_FORM_REQUEST_STATUS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        yield put({
          type: actions.FETCH_INTEGRATION_FORM_LOGS,
          payload: { integration_form_requests: [id] },
          pagination: { page: 0, limit: 20 }
        });

        yield put({
          type: actions.FETCH_INTEGRATION_FORM_REQUESTS,
          payload: {},
          pagination: { page: 0, limit: 10 }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_INTEGRATION_FORM_REQUEST_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_INTEGRATION_FORM_REQUEST_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_INTEGRATION_FORM_REQUEST_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* assignTOSToIRF() {
  yield takeEvery(actions.ASSIGN_TOS_TO_IRF, function* ({ payload }) {
    try {
      yield put({
        type: actions.ASSIGNING_TOS_TO_IRF,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield assignTOSToIRFAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ASSIGN_TOS_TO_IRF_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (payload?.integration_form_request_id) {
          yield put({
            type: actions.FETCH_INTEGRATION_FORM_LOGS,
            payload: { integration_form_requests: [payload?.integration_form_request_id] },
            pagination: { page: 0, limit: 20 }
          });
        }

        yield put({
          type: actions.FETCH_INTEGRATION_FORM_REQUESTS,
          payload: {},
          pagination: { page: 0, limit: 10 }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ASSIGN_TOS_TO_IRF_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ASSIGN_TOS_TO_IRF_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ASSIGN_TOS_TO_IRF_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchIntegrationFormLogs() {
  yield takeEvery('FETCH_INTEGRATION_FORM_LOGS', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_INTEGRATION_FORM_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchIntegrationFormLogsAPI(
        {
          ...payload
        },
        pagination,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_INTEGRATION_FORM_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_INTEGRATION_FORM_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INTEGRATION_FORM_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchMerchantProfileLogs() {
  yield takeEvery(actions.FETCH_MERCHANT_PROFILE_LOGS, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_PROFILE_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantProfileLogsAPI(
        {
          ...payload
        },
        pagination,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_PROFILE_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_PROFILE_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_PROFILE_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* loadMoreMerchantAuditLogs() {
  yield takeEvery(actions.LOAD_MORE_MERCHANT_AUDIT_LOGS, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.LOADING_MORE_MERCHANT_AUDIT_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantProfileLogsAPI(
        {
          ...payload
        },
        pagination,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.LOAD_MORE_MERCHANT_AUDIT_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.LOAD_MORE_MERCHANT_AUDIT_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOAD_MORE_MERCHANT_AUDIT_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchMidAuditLogs() {
  yield takeEvery(actions.FETCH_MID_AUDIT_LOGS, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MID_AUDIT_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMidAuditLogsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_MID_AUDIT_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MID_AUDIT_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MID_AUDIT_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* loadMoreMidAuditLogs() {
  yield takeEvery(actions.LOAD_MORE_MID_AUDIT_LOGS, function* ({ payload }) {
    try {
      yield put({
        type: actions.LOADING_MORE_MID_AUDIT_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMidAuditLogsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.LOAD_MORE_MID_AUDIT_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.LOAD_MORE_MID_AUDIT_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOAD_MORE_MID_AUDIT_LOGS_FAILED,
        loading: false
      });
    }
  });
}






export function* generateMerchantCredential() {
  yield takeEvery('GENERATE_MERCHANT_CREDENTIAL', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_MERCHANT_CREDENTIAL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateMerchantCredentialsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result) {
        yield put({
          type: actions.GENERATE_MERCHANT_CREDENTIAL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_MERCHANT_CREDENTIAL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_MERCHANT_CREDENTIAL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_MERCHANT_CREDENTIAL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantCredentialsByID() {
  yield takeEvery('FETCH_MERCHANT_CREDENTIALS_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_CREDENTIALS_BY_ID,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantCredentialsByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_CREDENTIALS_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          unmasked_fields: payload?.unmasked_fields,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_CREDENTIALS_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_CREDENTIALS_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addMerchantPaymentChannel() {
  yield takeEvery('ADD_MERCHANT_PAYMENT_CHANNEL', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_PAYMENT_CHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantPaymentChannelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.ADD_MERCHANT_PAYMENT_CHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_PAYMENT_CHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantPaymentChannelsByID() {
  yield takeEvery('FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_PAYMENT_CHANNELS_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantPaymentChannelsByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantKrakenPaymentChannelsByID() {
  yield takeEvery(actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantKrakenPaymentChannelsByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMerchantKrakenPaymentChannel() {
  yield takeEvery(actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantKrakenPaymentChannelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateActiveKrakenPaymentChannelStatus() {
  yield takeEvery(actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateActiveKrakenPaymentChannelStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMerchantPaymentChannel() {
  yield takeEvery('UPDATE_MERCHANT_PAYMENT_CHANNEL', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_PAYMENT_CHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantPaymentChannelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_PAYMENT_CHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_PAYMENT_CHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* deleteMerchantPaymentChannel() {
  yield takeEvery(actions.DELETE_MERCHANT_PAYMENT_CHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_MERCHANT_PAYMENT_CHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteMerchantPaymentChannelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DELETE_MERCHANT_PAYMENT_CHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_MERCHANT_PAYMENT_CHANNEL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_MERCHANT_PAYMENT_CHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* deleteRMEndorseIrfPaymentChannel() {
  yield takeEvery(actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_RM_ENDORSE_IRF_PAYMENT_CHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteRMEndorseIrfPaymentChannelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateActivePaymentChannelStatus() {
  yield takeEvery(actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_ACTIVE_PAYMENT_CHANNEL_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateActivePaymentChannelStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlsTestingProofFiles() {
  yield takeEvery('STORE_TESTING_PROOF_FILES_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_TESTING_PROOF_FILES_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsTestingProofFiles = state.Merchant.presignedUrlsTestingProofFiles;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getPresignedURLsWithKeyAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsTestingProofFiles && presignedUrlsTestingProofFiles.length > 0) {
          urlsArr.push(...presignedUrlsTestingProofFiles);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_TESTING_PROOF_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_TESTING_PROOF_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_TESTING_PROOF_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* uploadTestingProofFiles() {
  yield takeEvery('UPLOAD_TESTING_PROOF_FILES', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.UPLOADING_TESTING_PROOF_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let filesData = [];
      if (payload && payload.files && payload.files.length === urls.files.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.files.some(str => str.includes(file.name))) {
            let getURL = urls.files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              filesData.push(currentObj);
            }
          }
        });

        yield delay(urls.files.length * 1000);
      }

      const apiResult = yield uploadTestingProofFilesAPI(
        {
          ...payload,
          files: filesData
        },
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPLOAD_TESTING_PROOF_FILES_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_TESTING_PROOF_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_TESTING_PROOF_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_TESTING_PROOF_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* deleteTestingProofFiles() {
  yield takeEvery('DELETE_TESTING_PROOF_FILES', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_TESTING_PROOF_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield deleteTestingProofFilesAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DELETE_TESTING_PROOF_FILES_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_TESTING_PROOF_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_TESTING_PROOF_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_TESTING_PROOF_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchTestingProofFilesByID() {
  yield takeEvery(actions.FETCH_TESTING_PROOF_FILES_BY_ID, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TESTING_PROOF_FILES_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTestingProofFilesByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TESTING_PROOF_FILES_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_TESTING_PROOF_FILES_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TESTING_PROOF_FILES_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadTestingProofFile() {
  yield takeEvery(actions.DOWNLOAD_TESTING_PROOF_FILE, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_TESTING_PROOF_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadTestingProofFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_TESTING_PROOF_FILE_SUCCESS,
          loading: false,
          message: 'Attachment exported successfully.',
          result: result?.url
        });
        // if (result.url) {
        //   window.open(result.url, '_blank');
        // }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_TESTING_PROOF_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_TESTING_PROOF_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_TESTING_PROOF_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadIRFTestingProofFile() {
  yield takeEvery(actions.DOWNLOAD_IRF_TESTING_PROOF_FILE, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_IRF_TESTING_PROOF_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadIRFTestingProofFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_IRF_TESTING_PROOF_FILE_SUCCESS,
          loading: false,
          message: 'Attachment exported successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_IRF_TESTING_PROOF_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_IRF_TESTING_PROOF_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_IRF_TESTING_PROOF_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* releaseTOSCredentials() {
  yield takeEvery('RELEASE_TOS_CREDENTIALS', function* ({ payload }) {
    try {
      yield put({
        type: actions.RELEASING_TOS_CREDENTIALS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield releaseTOSCredentialsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.RELEASE_TOS_CREDENTIALS_SUCCESS,
          loading: false,
          message: result.message,
          result: result?.data
        });

        if (result.log) {
          yield put ({
            type: actions.UPDATE_AUDIT_LOGS,
            log: result.log
          })
        }

      } else {
        yield put({
          type: actions.RELEASE_TOS_CREDENTIALS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.RELEASE_TOS_CREDENTIALS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* releaseTOSConfiguration() {
  yield takeEvery('RELEASE_TOS_CONFIGURATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.RELEASING_TOS_CONFIGURATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield releaseTOSConfigurationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.RELEASE_TOS_CONFIGURATION_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        yield put({
          type: actions.RELEASE_TOS_CONFIGURATION_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.RELEASE_TOS_CONFIGURATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateIntegrationRequestFormReport() {
  yield takeEvery(actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_INTEGRATION_REQUEST_FORM_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateIntegrationRequestFormReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadIntegrationRequestFormReport() {
  yield takeEvery(actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_INTEGRATION_REQUEST_FORM_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadIntegrationRequestFormReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS,
          loading: false,
          message: 'Report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllIntegrationRequestFormReportData() {
  yield takeEvery(
    actions.FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchAllIntegrationRequestFormReportDataAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* getS3UrlsForIRFProdProofTestingFiles() {
  yield takeEvery('STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsForIRFProofTestFileData =
        state.Merchant.presignedUrlsForIRFProofTestFileData;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (
          presignedUrlsForIRFProofTestFileData &&
          presignedUrlsForIRFProofTestFileData.length > 0
        ) {
          urlsArr.push(...presignedUrlsForIRFProofTestFileData);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* uploadTestingIrfProofFiles() {
  yield takeEvery('UPLOAD_TESTING_PROOF_IRF_FILES', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.UPLOADING_TESTING_PROOF_IRF_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let filesData = [];
      if (payload && payload.files && payload.files.length === urls.files.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.files.some(str => str.includes(file.name))) {
            let getURL = urls.files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              filesData.push(currentObj);
            }
          }
        });

        yield delay(urls.files.length * 1000);
      }

      const apiResult = yield uploadTestingIrfProofFilesAPI(
        {
          ...payload,
          files: filesData
        },
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPLOAD_TESTING_PROOF_IRF_FILES_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        if (payload?.merchant_management_id) {
          yield put({
            type: actions.FETCH_MERCHANT_DATA_BY_ID,
            payload: payload.merchant_management_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_TESTING_PROOF_IRF_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_TESTING_PROOF_IRF_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_TESTING_PROOF_IRF_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchTestingIrfProofFilesByID() {
  yield takeEvery(actions.FETCH_TESTING_IRF_PROOF_FILES_BY_ID, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TESTING_IRF_PROOF_FILES_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTestingIrfProofFilesByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TESTING_IRF_PROOF_FILES_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_TESTING_IRF_PROOF_FILES_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TESTING_IRF_PROOF_FILES_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadTestingIrfProofFile() {
  yield takeEvery(actions.DOWNLOAD_TESTING_IRF_PROOF_FILE, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_TESTING_IRF_PROOF_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadTestingIrfProofFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_TESTING_IRF_PROOF_FILE_SUCCESS,
          loading: false,
          message: 'Attachment exported successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_TESTING_IRF_PROOF_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_TESTING_IRF_PROOF_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_TESTING_IRF_PROOF_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* deleteTestingMerchantProofFile() {
  yield takeEvery('DELETE_TESTING_MERCHANT_PROOF_FILE', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_TESTING_MERCHANT_PROOF_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield deleteTestingMerchantProofFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DELETE_TESTING_MERCHANT_PROOF_FILE_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        if (payload?.merchant_management_id) {
          yield put({
            type: actions.FETCH_MERCHANT_DATA_BY_ID,
            payload: payload.merchant_management_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_TESTING_MERCHANT_PROOF_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_TESTING_MERCHANT_PROOF_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_TESTING_MERCHANT_PROOF_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addMerchantCertificate() {
  yield takeEvery(actions.ADD_MERCHANT_CERTIFICATE, function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_CERTIFICATE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantCertificateAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.ADD_MERCHANT_CERTIFICATE_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        if (payload && payload.environment.toUpperCase() === 'TEST' && payload.merchant_id) {
          yield put({
            type: actions.FETCH_TEST_MERCHANT_CERTIFICATES,
            payload: { environment: payload.environment, merchant_id: payload.merchant_id }
          });
        } else if (payload && payload.environment.toUpperCase() === 'PROD' && payload.merchant_id) {
          yield put({
            type: actions.FETCH_PROD_MERCHANT_CERTIFICATES,
            payload: { environment: payload.environment, merchant_id: payload.merchant_id }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_CERTIFICATE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_CERTIFICATE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_CERTIFICATE_FAILED,
        message: 'Failed to add merchant certificate',
        loading: false
      });
    }
  });
}

export function* updateMerchantCertificate() {
  yield takeEvery(actions.UPDATE_MERCHANT_CERTIFICATE, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_CERTIFICATE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantCertificateAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_CERTIFICATE_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.environment.toUpperCase() === 'TEST' && payload.merchant_id) {
          yield put({
            type: actions.FETCH_TEST_MERCHANT_CERTIFICATES,
            payload: { environment: payload.environment, merchant_id: payload.merchant_id }
          });
        } else if (payload && payload.environment.toUpperCase() === 'PROD' && payload.merchant_id) {
          yield put({
            type: actions.FETCH_PROD_MERCHANT_CERTIFICATES,
            payload: { environment: payload.environment, merchant_id: payload.merchant_id }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_MERCHANT_CERTIFICATE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_MERCHANT_CERTIFICATE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_CERTIFICATE_FAILED,
        message: 'Failed to update merchant certificate',
        loading: false
      });
    }
  });
}

export function* updateMerchantCertificateStatus() {
  yield takeEvery(actions.UPDATE_MERCHANT_CERTIFICATE_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_CERTIFICATE_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantCertificateStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_CERTIFICATE_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.environment.toUpperCase() === 'TEST' && payload.merchant_id) {
          yield put({
            type: actions.FETCH_TEST_MERCHANT_CERTIFICATES,
            payload: { environment: payload.environment, merchant_id: payload.merchant_id }
          });
        } else if (payload && payload.environment.toUpperCase() === 'PROD' && payload.merchant_id) {
          yield put({
            type: actions.FETCH_PROD_MERCHANT_CERTIFICATES,
            payload: { environment: payload.environment, merchant_id: payload.merchant_id }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_MERCHANT_CERTIFICATE_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_MERCHANT_CERTIFICATE_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_CERTIFICATE_STATUS_FAILED,
        message: 'Failed to update merchant certificate status',
        loading: false
      });
    }
  });
}

export function* fetchTestMerchantCertificates() {
  yield takeEvery(actions.FETCH_TEST_MERCHANT_CERTIFICATES, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TEST_MERCHANT_CERTIFICATES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTestMerchantCertificatesAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.FETCH_TEST_MERCHANT_CERTIFICATES_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_TEST_MERCHANT_CERTIFICATES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_TEST_MERCHANT_CERTIFICATES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TEST_MERCHANT_CERTIFICATES_FAILED,
        message: 'Failed to process request merchant certificate',
        loading: false
      });
    }
  });
}

export function* fetchProdMerchantCertificates() {
  yield takeEvery(actions.FETCH_PROD_MERCHANT_CERTIFICATES, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PROD_MERCHANT_CERTIFICATES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchProdMerchantCertificatesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.FETCH_PROD_MERCHANT_CERTIFICATES_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PROD_MERCHANT_CERTIFICATES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_PROD_MERCHANT_CERTIFICATES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PROD_MERCHANT_CERTIFICATES_FAILED,
        message: 'Failed to process request merchant certificate',
        loading: false
      });
    }
  });
}

export function* fetchBusinessTypeRequiredFieldsData() {
  yield takeEvery(actions.FETCH_BUSINESS_TYPE_REQUIREMENT, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_BUSINESS_TYPE_REQUIREMENT,
        loading: true
      });

      const apiResult = yield fetchBusinessTypeRequiredFieldsAPI(payload);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_BUSINESS_TYPE_REQUIREMENT_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_BUSINESS_TYPE_REQUIREMENT_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BUSINESS_TYPE_REQUIREMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* saveUploadedFileMetadata() {
  yield takeEvery(actions.SAVE_UPLOADED_FILE_METADATA, function* ({ payload }) {
    try {
      yield put({
        type: actions.SAVING_UPLOADED_FILE_METADATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield saveUploadedFileMetadataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.SAVE_UPLOADED_FILE_METADATA_SUCCESS,
          loading: false,
          message: result.message
        });

        if (payload?.merchant_management_id) {
          yield put({
            type: actions.FETCH_MERCHANT_DATA_BY_ID,
            payload: payload.merchant_management_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.SAVE_UPLOADED_FILE_METADATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.SAVE_UPLOADED_FILE_METADATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SAVE_UPLOADED_FILE_METADATA_FAILED,
        message: 'Failed to update merchant certificate status',
        loading: false
      });
    }
  });
}

export function* updateUploadedFileMetadata() {
  yield takeEvery(actions.UPDATE_UPLOADED_FILE_METADATA, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATE_UPLOADED_FILE_METADATA_LOADING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateUploadedFileMetadataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.UPDATE_UPLOADED_FILE_METADATA_SUCCESS,
          loading: false,
          message: result.message
        });

        if (payload?.merchant_management_id) {
          yield put({
            type: actions.FETCH_MERCHANT_DATA_BY_ID,
            payload: payload.merchant_management_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_UPLOADED_FILE_METADATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_UPLOADED_FILE_METADATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_UPLOADED_FILE_METADATA_FAILED,
        message: 'Failed to update merchant certificate status',
        loading: false
      });
    }
  });
}

export function* migrateMerchantPaymentChannelConfig() {
  yield takeEvery(actions.MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG, function* ({ payload }) {
    try {
      yield put({
        type: actions.MIGRATING_MERCHANT_PAYMENT_CHANNEL_CONFIG,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield migrateMerchantPaymentChannelConfigAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result?.success) {
        yield put({
          type: actions.MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchCompanyProfileData() {
  yield takeEvery(actions.FETCH_COMPANY_PROFILE_DATA, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_COMPANY_PROFILE_DATA,
        loading: true
      });

      const safePayload = payload ?? {};
      const page = safePayload.page ?? 0;

      // Exclude page/limit from the key so it reflects the *filter*,
      // and combine with page so different pages of the same filter cache separately
      const { page: _p, limit: _l, ...filterOnly } = safePayload;
      const pageKey = `${JSON.stringify(filterOnly)}:${page + 1}`;

      const cache = yield select(state => state.Merchant.companyProfileDataCache?.[pageKey]);

      if (cache) {
        yield put({
          type: actions.FETCH_COMPANY_PROFILE_DATA_SUCCESS,
          loading: false,
          result: cache.data,
          pagination: cache.pagination,
          filter: safePayload,
          cache: {
            ...((yield select(state => state.Merchant.companyProfileDataCache)) || {})
          }
        });
        return;
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllMerchantAPI(safePayload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const currentCache = yield select(state => state.Merchant.companyProfileDataCache);
        const updatedCache = {
          ...(currentCache || {}),
          [pageKey]: {
            data: result.data,
            pagination: result.pagination
          }
        };

        yield put({
          type: actions.FETCH_COMPANY_PROFILE_DATA_SUCCESS,
          loading: false,
          result: result.data,
          pagination: result.pagination,
          filter: safePayload,
          cache: updatedCache
        });
      } else {
        yield put({ type: actions.FETCH_COMPANY_PROFILE_DATA_FAILED, loading: false });
      }
    } catch (error) {
      yield put({ type: actions.FETCH_COMPANY_PROFILE_DATA_FAILED, loading: false });
    }
  });
}

export function* getS3FileUrlFile() {
  yield takeEvery(actions.GET_S3_FILE_URL, function* ({ payload, resolve, reject }) {
    try {
      const apiResult = yield getURLForFileAPI(payload.fileName, payload.bucketKey);
      const result = apiResult.data;

      if (result.success) {
        if (resolve) resolve(result.data); // ✅ send back data to caller
      } else {
        if (reject) reject(result.message || 'Failed to get S3 URL');
      }
    } catch (error) {
      if (reject) reject(error);
    }
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}

function* commonFetchRequests(payload) {
  yield put({
    type: actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS,
    payload
  });
  yield put({
    type: onboardingAction.FETCH_MERCHANT_ONBOARDING_LOGS,
    payload,
    pagination: {
      page: 0,
      limit: 20
    }
  });
}

async function uploadFileToS3(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  });
}

function resettingTokenData(id) {
  return get(`resettokens/get_data_by_token/${id}`);
}

function newResetMerchantUserPasswordRequest(data, token) {
  return PUT(`authenticate/new_reset_password/${token}`, data);
}

function fetchAllMerchantAPI(data, roleAuth) {
  return post(`get-all/merchant`, data, null, null, roleAuth);
}

function fetchMerchantFilesAPI(data, roleAuth) {
  return post(`get-all/merchant-files`, data, null, null, roleAuth);
}

function fetchPtiMerchantUsersAPI(data, roleAuth) {
  return post(`get/merchant-users`, data, null, null, roleAuth);
}
function fetchAllMerchantInformationAPI(payload, roleAuth) {
  return post(`get-all/merchant-info`, payload, null, null, null, roleAuth);
}
function fetchAmountLevelAPI(roleAuth) {
  return get(`get-all/risk-profile`, null, null, null, null, roleAuth);
}
function fetchElasticMerchantAPI(roleAuth) {
  return get(`get-all-merchant/monitoring`, null, null, null, null, roleAuth);
}
function fetchParentMerchantAPI(roleAuth) {
  return get(`get-parent/merchant`, null, null, null, null, roleAuth);
}
function fetchMerchantByIDAPI(id, roleAuth) {
  return get(`get-by-id/merchant/${id}`, null, null, null, null, roleAuth);
}
function fetchMerchantCredentialsByMerchantManagementIdAPI(id, data, pagination, roleAuth) {
  return get(`get/merchant-mids-${id}`, data, pagination, null, null, roleAuth);
}

function addNewMerchantCertificateAPI(data, pagination, roleAuth) {
  return post(`merchant-certificate`, data, pagination, null, roleAuth);
}

function updateMerchantCertificateV2API(data, roleAuth) {
  return PUT(`merchant-certificate`, data, null, roleAuth)
}

function updateMidCertificateAPI (data, roleAuth) {
  return patch(`merchant-certificate/mid`, data, null, roleAuth)
}

function fetchMerchantCertificatesAPI(data, pagination, roleAuth) {
  return get(`merchant-certificate`, data, pagination, null, null, roleAuth);
}

function fetchMerchantCredentialByIdAPI(data, roleAuth) {
  return get(`get/merchant-mid`, data, null, null, null, roleAuth);
}

function fetchMerchantKrakenPaymentChannelsByMidAPI(data, roleAuth) {
  return get(`get/merchant-mid/payment-channels`, data, null, null, null, roleAuth);
}

function updateMerchantKrakenPaymentChannelByMidAPI(data, roleAuth) {
  return PUT(`update/merchant-mid/payment-channel`, data, null, roleAuth)
}

function updateMerchantKrakenPaymentChannelByMidStatusAPI(data, roleAuth) {
  return patch(`update/merchant-mid/payment-channel-status`, data, null, roleAuth);
}

function migrateMerchantKrakenPaymentByMidAPI(data, roleAuth) {
  return post(`migrate/merchant-mid/payment-channel`, data, null, roleAuth);
}

function fetchPaybizDetailsData(data, roleAuth) {
  return post(`get/paybiz-merchant-details`, data, null, null, roleAuth);
}

function editIntegrationChannelSubMIDAPI(data, id, roleAuth) {
  return PUT(`edit/integration-channel/sub-mid/${id}`, data, null, roleAuth);
}
function fetchMerchantInfoByIDAPI(id, roleAuth) {
  return get(`get-by-id/merchant-info/${id}`, null, null, null, null, roleAuth);
}
function fetchMerchantConfigAPI(id, roleAuth) {
  return get(`get-all/merchant-configuration/${id}`, null, null, null, null, roleAuth);
}
function fetchMerchantSettingsTypeAPI(data, roleAuth) {
  return post(`get-all/merchant-settings-type`, data, null, null, roleAuth);
}
function fetchMerchantPChannelByIDAPI(data, roleAuth) {
  return get(`get-by-id/merchant-payment/${data.merchant_id}`, null, null, null, null, roleAuth);
}
function fetchMerchantLogsByIDAPI(data, pagination, roleAuth) {
  return post(
    `get/system-logs`,
    data,
    pagination ? pagination : { page: 0, limit: 10 },
    null,
    roleAuth
  );
}
function fetchMerchantFilesByIDAPI(data, pagination, roleAuth) {
  return post(
    `get/file-management`,
    data,
    pagination ? pagination : { page: 0, limit: 10 },
    null,
    roleAuth
  );
}
function fetchMerchantPChannelCredentialAPI(id, roleAuth) {
  return get(`get/payment-channel/credentials/${id}`, null, null, null, null, roleAuth);
}
function fetchMerchantFeesAPI(id, roleAuth) {
  return get(`get/merchant-fees/${id}`, null, null, null, null, roleAuth);
}
function addMerchantDataAPI(data, roleAuth) {
  return post(`add/merchant`, data, null, null, roleAuth);
}
function addPTIDashboardUserAPI(data, roleAuth) {
  return post(`add/merchant-users`, data, null, null, roleAuth);
}
function registerDashboardMerchantAccountAPI(data) {
  return post(`sign-up/merchant-users`, data, null, null, null);
}
function updatePTIDashboardUserAPI(data, roleAuth) {
  return PUT(`edit/merchant-users`, data, null, roleAuth);
}
function fetchInvitedMerchantUserDataAPI(id) {
  return get(`fetch/merchant-user-invite/${id}`, null, null, null, null, null);
}
function addMerchantInformationAPI(data, roleAuth) {
  return post(`add/merchant-info`, data, null, null, roleAuth);
}

function inviteMerchantDataAPI(data, roleAuth) {
  return post(`invite/merchant`, data, null, null, roleAuth);
}

function fetchInvitedMerchantDataAPI(id) {
  return get(`fetch/invited-merchant-data/${id}`, null, null, null, null, null);
}

function logAccessMerchantInviteAPI(data, id) {
  return PUT(`log/invited-merchant-data/${id}`, data, null, null);
}

function addMerchantConfigurationDataAPI(data, roleAuth) {
  return post(`add/merchant-configuration/${data.merchant_id}`, data, null, null, roleAuth);
}
function addMerchantSettingsTypeAPI(data, roleAuth) {
  return post(`add/merchant-settings-type`, data, null, null, roleAuth);
}
function addAmountLevelAPI(data, roleAuth) {
  return post(`add/risk-profile`, data, null, null, roleAuth);
}
function editMigratedMidAPI(data, id, roleAuth) {
  return patch(`merchant-management/${id}/mid`, data, null, roleAuth);
}
function editMerchantBasicInformationAPI(data, id, roleAuth) {
  return PUT(`edit/merchant/${id}`, data, null, roleAuth);
}
function editMerchantInformationAPI(data, id, roleAuth) {
  return PUT(`edit/merchant-info/${id}`, data, null, roleAuth);
}
function editMerchantConfigAPI(data, id, roleAuth) {
  return PUT(`edit/merchant-configuration/${id}`, data, null, roleAuth);
}
function editMerchantAmountLevelAPI(data, id, roleAuth) {
  return PUT(`edit/risk-profile/${id}`, data, null, roleAuth);
}
function editMerchantSettingsTypeAPI(data, id, roleAuth) {
  return PUT(`edit/merchant-settings-type/${id}`, data, null, roleAuth);
}
function editMerchantOwnerInformationAPI(data, id, roleAuth) {
  return PUT(`edit-owner/merchant/${id}`, data, null, roleAuth);
}
function editMerchantContactInformationAPI(data, id, roleAuth) {
  return PUT(`edit-contact/merchant/${id}`, data, null, roleAuth);
}
function editMerchantServiceInformationAPI(data, id, roleAuth) {
  return PUT(`edit-service/merchant/${id}`, data, null, roleAuth);
}
function setupMerchantPChannelCredentialAPI(data, id, roleAuth) {
  return post(`modify/payment-channel/credentials/${id}`, data, null, null, roleAuth);
}
function setupMerchantFeeAPI(data, id, roleAuth) {
  return post(`modify/merchant-fees/${id}`, data, null, null, roleAuth);
}
function editMerchantPChannelInformationAPI(data, id, roleAuth, request) {
  if (request.toUpperCase() === REQUEST.PUT) {
    return PUT(`edit/merchant-payment/${id}`, data, null, roleAuth);
  } else {
    return post(`add/merchant-payment/${id}`, data, null, null, roleAuth);
  }
}
function deleteMerchantDataAPI(id, roleAuth) {
  return DELETE(`delete/merchant/${id}`, null, null, roleAuth);
}
function filterMerchantAPI(data, roleAuth) {
  return post(`get-all-filtered/merchant`, data, null, null, roleAuth);
}
function uploadFileDataAPI(data, roleAuth) {
  return post(`upload/file-management`, data, null, null, roleAuth);
}
function downloadFileDataAPI(data, roleAuth) {
  return post(`download/file-management`, data, null, null, roleAuth);
}
function deleteFileDataAPI(id, roleAuth) {
  return DELETE(`delete/file-management/${id}`, null, null, roleAuth);
}
function fetchMISOptionsDataAPI() {
  return get(`fetch/mis-options`, null, null, null, null, null);
}
function fetchMISMerchantDetailsAPI(id) {
  return get(`fetch/mis-merchant-details/${id}`, null, null, null, null, null);
}
function fetchKybLinkStatusAPI(id) {
  return get(`fetch/kyb-link-status/${id}`, null, null, null, null, null);
}
function logAccessMISAPI(data, id) {
  return PUT(`log/mis-merchant-details/${id}`, data, null, null);
}
function submitMISFormDataAPI(data) {
  return post(`process/mis-merchant-details`, data, null, null, null);
}
function saveMISDraftAPI(data) {
  return post(`mis-drafts/save-draft`, data, null, null, null);
}
function fetchAllMerchantFromOnboardingAPI(data, roleAuth) {
  return post(`fetch/merchants-from-onboarding`, data, null, null, roleAuth);
}
function fetchMerchantServicesAndPaymentChannelsAPI(id, roleAuth) {
  return get(`fetch/merchant/services-and-payment-channel/${id}`, null, null, null, null, roleAuth);
}
function editMerchantServiceAPI(data, roleAuth) {
  return PUT(`edit/merchant-service`, data, null, roleAuth);
}
function editMerchantPaymentChannelAPI(data, roleAuth) {
  return PUT(`edit/merchant-payment-channel`, data, null, roleAuth);
}
function getAllCosmosLeadMerchantAPI(roleAuth) {
  return get(`get-all/lead-merchant`, null, null, null, null, roleAuth);
}

function fetchAllCompanyInformationAPI(roleAuth) {
  return get(`existing-companies`, null, null, null, null, roleAuth);
}

function addCompanyInformationAPI(data, roleAuth) {
  return post(`existing-companies`, data, null, null, roleAuth);
}

function editCompanyInformationAPI(id, data, roleAuth) {
  return PUT(`existing-companies/${id}`, data, null, roleAuth);
}

function fetchExistingMerchantLogsAPI(id, pagination, roleAuth) {
  return get(
    `existing-merchants/${id}/existing-merchant-logs`,
    null,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    roleAuth
  );
}

function downloadMerchantFileAPI(id, roleAuth) {
  return get(`download-merchant-file/${id}`, null, null, null, null, roleAuth);
}

function fetchAllParentMerchantsAPI(roleAuth) {
  return post(`get-all/parent-merchants`, null, null, null, null, roleAuth);
}

function migrateMerchantInformationAPI(data, roleAuth) {
  return post(`migrate/merchant-info`, data, null, null, roleAuth);
}

function fetchMerchantInfoMIDsAPI(data, roleAuth) {
  return post(`fetch/merchant-mids`, data, null, null, null, roleAuth);
}

function fetchIntegrationFormRequestsAPI(data, payload, roleAuth) {
  return post(`get-all/integration-form-requests`, data, payload, null, null, roleAuth);
}

function fetchIntegrationFormRequestByIdAPI(data, roleAuth) {
  return post(`get-by-id/integration-form-request`, data, null, null, roleAuth);
}

function updateIntegrationFormRequestStatusAPI(data, id, roleAuth) {
  return PUT(`integration-form-request/${id}/status`, data, null, roleAuth);
}

function assignTOSToIRFAPI(data, roleAuth) {
  return PUT(`integration-form-request/assign-tos`, data, null, roleAuth);
}

function generateIntegrationRequestFormReportAPI(data, roleAuth) {
  return post(`generate-integration-request-form-report`, data, null, roleAuth);
}

function downloadIntegrationRequestFormReportAPI(data, roleAuth) {
  return post(`download-integration-request-form-report`, data, null, roleAuth);
}

function fetchAllIntegrationRequestFormReportDataAPI(data, pagination, roleAuth) {
  return post(
    `get-all/merchant-integration-request-form-reports`,
    data,
    pagination,
    null,
    roleAuth
  );
}

function fetchIntegrationFormLogsAPI(data, payload, roleAuth) {
  return post(`get-all/integration-form-logs`, data, payload, null, null, roleAuth);
}

function fetchMerchantProfileLogsAPI(data, payload, roleAuth) {
  return post(`get-all/merchant-profile-logs`, data, payload, null, null, roleAuth);
}

function fetchMidAuditLogsAPI(data, roleAuth) {
  return post(`get-all/merchant-mid-logs`, data, null, null ,null, roleAuth)
}

function fetchMerchantCredentialsByIdAPI(data, roleAuth) {
  return post(`get-by-id/merchant-credentials`, data, null, null, roleAuth);
}

function generateMerchantCredentialsAPI(data, roleAuth) {
  return PUT(`generate/merchant-credentials`, data, null, roleAuth);
}

function addMerchantPaymentChannelAPI(data, roleAuth) {
  return post(`add/merchant-payment-channels`, data, null, null, roleAuth);
}

function fetchMerchantPaymentChannelsByIdAPI(data, roleAuth) {
  return post(`get-by-id/merchant-payment-channels`, data, null, null, roleAuth);
}

function fetchMerchantKrakenPaymentChannelsByIdAPI(data, roleAuth) {
  return post(`get-by-id/merchant-kraken-payment-channels`, data, null, null, roleAuth);
}

function updateMerchantPaymentChannelAPI(data, roleAuth) {
  return PUT(`edit/merchant-payment-channels`, data, null, roleAuth);
}

function deleteMerchantPaymentChannelAPI(data, roleAuth) {
  return post(`delete/merchant-payment-channels`, data, null, null, roleAuth);
}

function updateActivePaymentChannelStatusAPI(data, roleAuth) {
  return PUT(`edit/merchant-payment-channels/active-status`, data, null, roleAuth);
}

function updateMerchantKrakenPaymentChannelAPI(data, roleAuth) {
  return PUT(`edit/merchant-kraken-payment-channels`, data, null, roleAuth);
}

function updateActiveKrakenPaymentChannelStatusAPI(data, roleAuth) {
  return PUT(`edit/merchant-kraken-payment-channels/active-status`, data, null, roleAuth);
}

function getPresignedURLsWithKeyAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}

function uploadTestingProofFilesAPI(data, roleAuth) {
  return post(`add/testing-proof-files`, data, null, null, roleAuth);
}

function deleteTestingProofFilesAPI(data, roleAuth) {
  return post(`delete/testing-proof-files`, data, null, null, roleAuth);
}

function fetchTestingProofFilesByIdAPI(data, roleAuth) {
  return post(`get-by-id/testing-proof-files`, data, null, null, roleAuth);
}

function downloadTestingProofFileAPI(data, roleAuth) {
  return post(`download/testing-proof-files`, data, null, null, roleAuth);
}

function downloadIRFTestingProofFileAPI(data, roleAuth) {
  return post(`download/irf-testing-proof-files`, data, null, null, roleAuth);
}

function releaseTOSCredentialsAPI(data, roleAuth) {
  return post(`released/tos-credentials`, data, null, null, roleAuth);
}

function releaseTOSConfigurationAPI(data, roleAuth) {
  return post(`release/tos-configuration`, data, null, null, roleAuth);
}

function getURLsFilesAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}

function uploadTestingIrfProofFilesAPI(data, roleAuth) {
  return post(`add/testing-irf-proof-files`, data, null, null, roleAuth);
}

function fetchTestingIrfProofFilesByIdAPI(data, roleAuth) {
  return post(`get-by-id/testing-irf-proof-files`, data, null, null, roleAuth);
}

function downloadTestingIrfProofFileAPI(data, roleAuth) {
  return post(`download/testing-irf-proof-files`, data, null, null, roleAuth);
}

function deleteTestingMerchantProofFileAPI(data, roleAuth) {
  return post(`delete/testing-irf-proof-files`, data, null, null, roleAuth);
}

function addMerchantCertificateAPI(data, roleAuth) {
  return post(`add/merchant-certification`, data, null, null, roleAuth);
}

function updateMerchantCertificateAPI(data, roleAuth) {
  return PUT(`edit/merchant-certification`, data, null, roleAuth);
}

function updateMerchantCertificateStatusAPI(data, roleAuth) {
  return PUT(`edit/merchant-certification-status`, data, null, roleAuth);
}

function fetchTestMerchantCertificatesAPI(data, roleAuth) {
  return post(`get/merchant-certifications`, data, null, null, roleAuth);
}

function fetchProdMerchantCertificatesAPI(data, roleAuth) {
  return post(`get/merchant-certifications`, data, null, null, roleAuth);
}

function fetchBusinessTypeRequiredFieldsAPI(data) {
  return post('fetch/moc-business-type-required-fields', data, null, null, null);
}

function saveUploadedFileMetadataAPI(data, roleAuth) {
  return PUT(`save/uploaded-file-metadata`, data, null, roleAuth);
}

function updateUploadedFileMetadataAPI(data, roleAuth) {
  return PUT(`update/uploaded-file-metadata`, data, null, roleAuth);
}

function getURLForFileAPI(key, bucketKey) {
  return get(
    `get/utility/presigned-s3-url-with-key/kyb-link/${bucketKey}/${key}`,
    null,
    null,
    null,
    null,
    null
  );
}

function migrateMerchantPaymentChannelConfigAPI (data, roleAuth) {
  return post(`migrate/merchant-payment-channel-config`, data, null, null, roleAuth)
}

function deleteRMEndorseIrfPaymentChannelAPI(data, roleAuth) {
  return post(`delete/endorsed-payment-channel`, data, null, null, roleAuth);
}

export default function* rootSaga() {
  yield all([
    fork(resetTokenData),
    fork(newResetMerchantUserPassword),
    fork(fetchAllMerchants),
    fork(fetchPtiTestMerchantUsers),
    fork(fetchPtiProdMerchantUsers),
    fork(addPtiMerchantUser),
    fork(registerDashboardMerchantAccount),
    fork(updatePtiMerchantUser),
    fork(fetchInvitedMerchantUserDetails),
    fork(fetchElasticMerchants),
    fork(fetchMerchantByID),
    fork(addMerchantData),
    fork(inviteMerchantData),
    fork(fetchInvitedMerchantDetails),
    fork(logAccessMerchantInvite),
    fork(editMerchantBasicInformationData),
    fork(editMerchantOwnerInformationData),
    fork(editMerchantContactInformationData),
    fork(editMerchantServiceInformationData),
    fork(deleteMerchantData),
    fork(filterMerchantData),
    fork(fetchMerchantFiles),
    fork(fetchMerchantPchannelByID),
    fork(fetchMerchantLogsByID),
    fork(fetchAmountLevel),
    fork(fetchParentMerchants),
    fork(editMerchantPChannelInformationData),
    fork(fetchMerchantFilesByID),
    fork(uploadFileData),
    fork(downloadFileData),
    fork(deleteFileData),
    fork(fetchMerchantConfiguration),
    fork(fetchMerchantSettingsType),
    fork(addAmountLevel),
    fork(addMerchantSettingsType),
    fork(editMerchantSettingsTypeData),
    fork(editMerchantAmountLevelData),
    fork(addMerchantConfigurationData),
    fork(editMerchantConfigData),
    fork(fetchMerchantPChannelCredentialByID),
    fork(setupMerchantPChannelCredential),
    fork(fetchMerchantFees),
    fork(setupMerchantFee),
    fork(addMerchantInformation),
    fork(fetchMerchantInfoByID),
    fork(fetchAllMerchantInfo),
    fork(editMerchantInformation),
    fork(fetchMISOptionsData),
    fork(fetchMerchantMISDetails),
    fork(logAccessMIS),
    fork(saveMISDraft),
    fork(submitMISFormData),
    fork(fetchAllMerchantFromOnboarding),
    fork(editMerchantService),
    fork(fetchMerchantServicesAndPaymentChannels),
    fork(editMerchantPaymentChannel),
    fork(getAllCosmosLeadMerchant),
    fork(fetchExistingMerchantLogs),
    fork(fetchAllCompanyInformation),
    fork(addCompanyInformation),
    fork(editCompanyInformation),
    fork(downloadMerchantFile),
    fork(fetchAllParentMerchants),
    fork(migrateMerchantInformation),
    fork(fetchPaybizDetailsByID),
    fork(fetchPaybizMerchants),
    fork(fetchMerchantInfoMIDs),
    fork(fetchIntegrationFormRequests),
    fork(fetchIntegrationFormRequestByID),
    fork(editIntegrationChannelSubMID),
    fork(updateIntegrationFormRequestStatus),
    fork(assignTOSToIRF),
    fork(generateIntegrationRequestFormReport),
    fork(downloadIntegrationRequestFormReport),
    fork(fetchAllIntegrationRequestFormReportData),
    fork(fetchIntegrationFormLogs),
    fork(fetchMerchantProfileLogs),
    fork(generateMerchantCredential),
    fork(fetchMerchantCredentialsByID),
    fork(addMerchantPaymentChannel),
    fork(fetchMerchantPaymentChannelsByID),
    fork(fetchMerchantKrakenPaymentChannelsByID),
    fork(updateMerchantPaymentChannel),
    fork(deleteMerchantPaymentChannel),
    fork(updateActivePaymentChannelStatus),
    fork(updateMerchantKrakenPaymentChannel),
    fork(updateActiveKrakenPaymentChannelStatus),
    fork(getS3UrlsTestingProofFiles),
    fork(uploadTestingProofFiles),
    fork(fetchTestingProofFilesByID),
    fork(downloadTestingProofFile),
    fork(downloadIRFTestingProofFile),
    fork(deleteTestingProofFiles),
    fork(releaseTOSCredentials),
    fork(releaseTOSConfiguration),
    fork(getS3UrlsForIRFProdProofTestingFiles),
    fork(uploadTestingIrfProofFiles),
    fork(fetchTestingIrfProofFilesByID),
    fork(downloadTestingIrfProofFile),
    fork(deleteTestingMerchantProofFile),
    fork(fetchKybLinkStatus),
    fork(addMerchantCertificate),
    fork(updateMerchantCertificate),
    fork(updateMerchantCertificateStatus),
    fork(fetchTestMerchantCertificates),
    fork(fetchProdMerchantCertificates),
    fork(fetchBusinessTypeRequiredFieldsData),
    fork(getS3FileUrlFile),
    fork(saveUploadedFileMetadata),
    fork(updateUploadedFileMetadata),
    fork(editMigratedMid),
    fork(migrateMerchantPaymentChannelConfig),
    fork(deleteRMEndorseIrfPaymentChannel),
    fork(fetchMerchantCredentialsByMerchantManagementId),
    fork(loadMoreMerchantCredentials),
    fork(addNewMerchantCertificate),
    fork(fetchMerchantCertificates),
    fork(updateMerchantCertificateV2),
    fork(updateMidCertificate),
    fork(fetchMerchantCredentialById),
    fork(fetchMerchantKrakenPaymentChannelsByMid),
    fork(updateMerchantKrakenPaymentChannelByMid),
    fork(updateMerchantKrakenPaymentChannelByMidStatus),
    fork(migrateMerchantKrakenPaymentByMid),
    fork(fetchMidAuditLogs),
    fork(loadMoreMidAuditLogs),
    fork(loadMoreMerchantAuditLogs),
    fork(fetchPtiMerchantUsers),
    fork(fetchCompanyProfileData)
  ]);
}
